import React from "react";
import { useSelector } from "react-redux";
import { documentBy } from "constants/discovery";
import ByTheme from "layout/discovery/document/ByTheme";
import ByContent from "layout/discovery/document/ByContent";

const DiscoveryDocument = () => {
  const docBy = useSelector((state) => state.discovery.config.documentBy);

  return docBy === documentBy.theme ? <ByTheme /> : <ByContent />;
};

export default DiscoveryDocument;
